export enum DeployTypes {
  BACKOFFICE = 'BACKOFFICE_DEPLOY',
  PORTAL = 'PORTAL_DEPLOY',
}
